import { Base } from './../base';

export class ModelType extends Base{

}